<template>
    <div class="search-main" v-if="fieldList.length>0">
        <div class="search-item" v-for="(item,index) in fieldList" :key="index">
            <div class="search-item-input" v-if="item.type==='text'||item.type==='serialNumber'">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                 <div class="lable">
                     {{item.name}}
                 </div>
                </el-tooltip>
               <div class="option">
                   <input type="text" v-model="item.conditionValue"/>
               </div>
            </div>
           <div class="search-item-input" v-if="item.type==='date'">
               <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                <div class="lable">
                    {{item.name}}
                </div>
               </el-tooltip>
               <div class="option">
                  <el-date-picker
                     type="date"
                     v-model="item.conditionValue"
                     :editable="true"
                     placeholder="选择日期">
                   </el-date-picker>
               </div>
            </div>
            <div class="search-item-select" v-if="item.type==='select'">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                 <div class="lable">
                     {{item.name}}
                 </div>
                </el-tooltip>
                <div class="option">
                   <el-select v-model="item.conditionValue" placeholder="请选择" clearable>
                      <el-option
                        v-for="cur in item.options"
                        :key="cur.id"
                        :label="cur.title"
                        :value="cur.id">
                      </el-option>
                    </el-select>
                </div>
             </div>
             <div class="search-item-select" v-if="item.type==='user'">
                 <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                  <div class="lable">
                      {{item.name}}
                  </div>
                 </el-tooltip>
                 <div class="option">
                  <el-select
                      v-model="item.conditionValue"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入关键词"
                      :remote-method="queryUserList"
                      :loading="loading"
                      @change="selectTrigger(item)">
                      <el-option
                          v-for="obj in userList"
                          :key="obj.userId"
                          :label="obj.trueName"
                          :value="obj.userId">
                      </el-option>
                  </el-select>
                 </div>
              </div>
             <div class="search-item-category" v-if="item.type==='category'">
                 <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                  <div class="lable">
                      {{item.name}}
                  </div>
                 </el-tooltip>
                 <div class="option">
                    <el-radio-group v-model="item.conditionValue"  v-if="item.twoType==='single'">
                        <el-radio v-for="cur in item.options" :label="cur.title" :key="cur.id" :value="cur.id"></el-radio>
                    </el-radio-group>
                    <el-checkbox-group v-model="item.conditionValue" v-else>
                        <el-checkbox v-for="cur in item.options" :label="cur.title" :key="cur.id" :value="cur.id"></el-checkbox>
                    </el-checkbox-group>
                 </div>
              </div>
        </div>
        <div class="search-item">
            <el-button type="primary"  @click="searchData">查询</el-button>
            <!-- <i class="el-icon-search" @click="searchData"></i> -->
        </div>
       <!-- <el-collapse accordion v-if="fieldList.length>0">
            <el-collapse-item>
                <template slot="title">
                   快捷搜索
                </template>
                <div class="search-item" v-for="(item,index) in fieldList" :key="index">
                    <div class="search-item-input" v-if="item.type==='text'||item.type==='serialNumber'">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                         <div class="lable">
                             {{item.name}}
                         </div>
                        </el-tooltip>
                       <div class="option">
                           <input type="text" v-model="item.conditionValue"/>
                       </div>
                    </div>
                   <div class="search-item-input" v-if="item.type==='date'">
                       <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                        <div class="lable">
                            {{item.name}}
                        </div>
                       </el-tooltip>
                       <div class="option">
                          <el-date-picker
                             type="date"
                             v-model="item.conditionValue"
                             placeholder="选择日期">
                           </el-date-picker>
                       </div>
                    </div>
                    <div class="search-item-select" v-if="item.type==='select'">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                         <div class="lable">
                             {{item.name}}
                         </div>
                        </el-tooltip>
                        <div class="option">
                           <el-select v-model="item.conditionValue" placeholder="请选择" clearable>
                              <el-option
                                v-for="cur in item.options"
                                :key="cur.id"
                                :label="cur.title"
                                :value="cur.id">
                              </el-option>
                            </el-select>
                        </div>
                     </div>
                     <div class="search-item-select" v-if="item.type==='user'">
                         <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                          <div class="lable">
                              {{item.name}}
                          </div>
                         </el-tooltip>
                         <div class="option">
                          <el-select
                              v-model="item.conditionValue"
                              filterable
                              remote
                              clearable
                              reserve-keyword
                              placeholder="请输入关键词"
                              :remote-method="queryUserList"
                              :loading="loading"
                              @change="selectTrigger(item)">
                              <el-option
                                  v-for="obj in userList"
                                  :key="obj.userId"
                                  :label="obj.trueName"
                                  :value="obj.userId">
                              </el-option>
                          </el-select>
                         </div>
                      </div>
                     <div class="search-item-category" v-if="item.type==='category'">
                         <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                          <div class="lable">
                              {{item.name}}
                          </div>
                         </el-tooltip>
                         <div class="option">
                            <el-radio-group v-model="item.conditionValue"  v-if="item.twoType==='single'">
                                <el-radio v-for="cur in item.options" :label="cur.title" :key="cur.id" :value="cur.id"></el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-model="item.conditionValue" v-else>
                                <el-checkbox v-for="cur in item.options" :label="cur.title" :key="cur.id" :value="cur.id"></el-checkbox>
                            </el-checkbox-group>
                         </div>
                      </div>
                </div>
                <div class="search-item">
                    <i class="el-icon-search" @click="searchData"></i>
                </div>
            </el-collapse-item>
        </el-collapse> -->
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    import { getUserList } from '@/data-model';
    export default{
        name: 'SearchTool',
        props: {
            searchField: {
                type: Array
            }
        },
        data () {
            return {
                fieldList: [],
                loading: false,
                userList: []
            };
        },
        created () {
            this.initSearchField();
        },
        methods: {
            initSearchField () {
                let fieldArr = [];
                for (let i = 0; i < this.searchField.length; i++) {
                    let cur = this.searchField[i].obj;
                    let obj = cloneDeep(cur);
                    obj.name = cur.name;
                    obj.type = cur.type;
                    obj.id = cur.id;
                    obj.formField = cur.formField;
                    if (obj.type === 'select') {
                        obj.options = cur.options.config.options;
                    } else if (obj.type === 'category') {
                        let type = cur.options.config.type;
                        obj.twoType = type;
                        obj.options = cur.options.config.options;
                    } else if (obj.type === 'user' && this.userList.length < 1) {
                        this.queryUserList('');
                    }
                    fieldArr.push(obj);
                }
                this.fieldList = fieldArr;
            },
            searchData () {
                this.$emit('searchData', this.fieldList);
            },
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            selectTrigger (obj) {
                let user = this.userList.find(i => i.userId === obj.conditionValue);
                obj.trueName = user.trueName;
                obj.userId = user.userId;
                obj.userName = user.userName;
                obj.conditionValueView = user.trueName;
            }
        }
    };
</script>

<style lang="less">
    .search-main{
        height: auto;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        .search-item{
            cursor: pointer;
            margin-left: 10px;
            margin-top: 10px;
            height: 38px;
            line-height: 34px;
            .el-icon-search{
                font-size: 22px;
                margin-top: 6px;
            }
            .search-item-input,.search-item-select,.search-item-category{
                display: flex;
                height: 34px;
                line-height: 34px;
                .lable{
                     background: #F2F2F2;
                     height: 32px;
                     line-height: 32px;
                     width: auto;
                     text-align: center;
                     padding: 2px 6px;
                     width: 60px;
                     display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                     -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                     overflow: hidden; /*超出的文本隐藏*/
                     text-overflow: ellipsis; /* 溢出用省略号*/
                     -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                }
                .option{
                    height: 32px;
                    line-height: 32px;
                    input{
                        border: 1px solid #f2f2f2;
                        height: 32px;
                        line-height: 32px;
                        outline-style: none ;
                        text-indent: 4px;
                        width: 140px;
                    }
                    .el-input__inner{
                        height: 36px;
                        line-height: 36px;
                        border-radius: 0px;
                        width: 140px;
                    }
                    .el-select{
                        .el-input__inner{
                            width: 146px;
                        }
                    }
                    .el-date-editor--date{
                        width: 146px;
                        .el-input__inner{
                            width: 146px;
                        }
                    }
                    .el-radio-group{
                        margin-left: 10px;
                    }
                }
            }
        }
        // .el-collapse{
        //     width: 100%;
        //     .el-collapse-item{
        //         width: 100%;
        //         .el-collapse-item__header {
        //             padding-left: 10px;
        //         }
        //         .el-collapse-item__wrap{
        //             .el-collapse-item__content{
        //                 width: 100%;
        //                 display: flex;
        //                 flex-wrap: wrap;
        //                 .search-item{
        //                     cursor: pointer;
        //                     margin-left: 10px;
        //                     margin-top: 10px;
        //                     .el-icon-search{
        //                         font-size: 24px;
        //                         margin-top: 6px;
        //                     }
        //                     .search-item-input,.search-item-select,.search-item-category{
        //                         display: flex;
        //                         height: 34px;
        //                         line-height: 34px;
        //                         .lable{
        //                              background: #F2F2F2;
        //                              height: 32px;
        //                              line-height: 32px;
        //                              width: auto;
        //                              text-align: center;
        //                              padding: 2px 6px;
        //                              width: 60px;
        //                              display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        //                              -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        //                              overflow: hidden; /*超出的文本隐藏*/
        //                              text-overflow: ellipsis; /* 溢出用省略号*/
        //                              -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
        //                         }
        //                         .option{
        //                             height: 32px;
        //                             line-height: 32px;
        //                             input{
        //                                 border: 1px solid #f2f2f2;
        //                                 height: 32px;
        //                                 line-height: 32px;
        //                                 outline-style: none ;
        //                                 text-indent: 4px;
        //                                 width: 140px;
        //                             }
        //                             .el-input__inner{
        //                                 height: 36px;
        //                                 line-height: 36px;
        //                                 border-radius: 0px;
        //                                 width: 140px;
        //                             }
        //                             .el-select{
        //                                 .el-input__inner{
        //                                     width: 146px;
        //                                 }
        //                             }
        //                             .el-date-editor--date{
        //                                 width: 146px;
        //                                 .el-input__inner{
        //                                     width: 146px;
        //                                 }
        //                             }
        //                             .el-radio-group{
        //                                 margin-left: 10px;
        //                             }
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/SearchTools.vue